/**
 * Resuelve el `src` de una imagen de evento: portada, galería y —desde GTK-802—
 * también la foto del host.
 *
 * Dos formatos de almacenamiento:
 *  1. Base64 legado: imageFormat = "data:image/jpeg;base64", imageBase64 = "<datos>"
 *     → devuelve "data:image/jpeg;base64,<datos>"
 *  2. URL de S3 (el actual): imageFormat = "https://...jpg#", imageBase64 = ""
 *     → devuelve "https://...jpg#" (el # final es inocuo en un <img src>)
 *
 * Por qué el "#": la app mobile anterior a la 4.8.1 hacía `imageFormat + "," + imageBase64`
 * sin mirar si el primero era una URL, así que sin el fragmento le quedaba "...jpg," y
 * daba 404. Desde la 4.8.1 (commit c71746a, marzo 2026) `ImageBase64` corta antes:
 * `if (imageFormat?.startsWith("http")) return { uri: imageFormat }`, o sea que para la
 * app actual el "#" ya no hace falta. Se mantiene porque la app NO tiene OTA
 * (no hay expo-updates): el JS de cada binario queda congelado y los usuarios que no
 * actualizaron siguen ejecutando la concatenación vieja. Antes de sacarlo hay que
 * confirmar la versión mínima forzada que sirve /system.
 */
export function getEventImageSrc(
  imageFormat?: string | null,
  imageBase64?: string | null,
  fallback: string = "/assets/images/Image-not-found.png"
): string {
  if (!imageFormat) return fallback;

  // S3 URL format: imageFormat contains the full URL (ends with #)
  if (imageFormat.startsWith("http://") || imageFormat.startsWith("https://")) {
    return imageFormat;
  }

  // Legacy base64 format
  if (imageBase64) {
    return `${imageFormat},${imageBase64}`;
  }

  return fallback;
}
